import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider, CartProvider } from "@/lib/store";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Authenticity from "@/pages/Authenticity";
import { BlogList, BlogPost } from "@/pages/Blog";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import OrderHistory from "@/pages/OrderHistory";
import AuthCallback from "@/pages/AuthCallback";
import Finder from "@/pages/Finder";
import AdminList from "@/pages/AdminList";
import AdminEdit from "@/pages/AdminEdit";
import AdminOrders from "@/pages/AdminOrders";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminUpsSettings from "@/pages/AdminUpsSettings";
import AdminEmails from "@/pages/AdminEmails";
import AdminFraud from "@/pages/AdminFraud";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // OAuth callback returns with #session_id in hash — process before regular routing.
  // Read from useLocation().hash (reactive) NOT window.location.hash.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navbar />
      <main data-testid="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/producto/:slug" element={<Product />} />
          <Route path="/finder" element={<Finder />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/autenticidad" element={<Authenticity />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/pedidos" element={<OrderHistory />} />
          <Route path="/account/*" element={<Account />} />
          <Route path="/admin" element={<AdminList />} />
          <Route path="/admin/producto/:id" element={<AdminEdit />} />
          <Route path="/admin/pedidos" element={<AdminOrders />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/ajustes/ups" element={<AdminUpsSettings />} />
          <Route path="/admin/emails" element={<AdminEmails />} />
          <Route path="/admin/fraude" element={<AdminFraud />} />
          <Route path="*" element={<div className="p-24 text-center"><h1 className="font-serif text-6xl">404</h1><p className="mt-4 text-muted-foreground">Página no encontrada.</p></div>} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="bottom-right" />
          </AuthProvider>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}
